import React from 'react';
import PropTypes from 'prop-types';
import Translations from '../../../../../requests/apa/Translator';
import './_MatchDetailLineupsCoaches.scss';
import Asset from '../../../../../requests/apa/Asset';

const getCoachData = (team) => {
  var coach = team && team.coach ? team.coach : {};
  var name = coach.name || (team && team.coachName);
  var coachPlaceholder = Asset.get('eventodeportivo_placeholder_imagen_jugador_1');
  var photoUrl = coach.photoUrl
    || coach.photo
    || coach.imageUrl
    || coach.image
    || (team && team.coachPhotoUrl)
    || (team && team.coachImage)
    || coachPlaceholder;

  return {
    name: name,
    photoUrl: photoUrl
  };
};

const CoachCard = ({ side, coach, teamColor }) => {
  var isAway = side === 'away';
  var borderStyle = teamColor ? { border: '0.133rem solid ' + teamColor, boxSizing: 'border-box' } : {};
  return (
    <div className={'lineups-coaches__coach lineups-coaches__coach--' + side}>
      <span className="lineups-coaches__title">{Translations.get('eventodeportivo_partidos_alineaciones_texto_titulo_directortecnico')}</span>
      <span className="lineups-coaches__row">
        {isAway ? <span className="lineups-coaches__name-badge lineups-coaches__name-badge--away">{coach.name}</span> : null}
        <span className={'lineups-coaches__photo-wrap lineups-coaches__photo-wrap--' + side} style={borderStyle}>
          <img
            src={coach.photoUrl || Asset.get('eventodeportivo_placeholder_imagen_jugador_1')}
            alt={coach.name}
            className="lineups-coaches__photo"
            onError={function(e) {
              e.target.onerror = null;
              e.target.src = Asset.get('eventodeportivo_placeholder_imagen_jugador_1');
            }}
          />
        </span>
        {!isAway ? <span className="lineups-coaches__name-badge">{coach.name}</span> : null}
      </span>
    </div>
  );
};

CoachCard.propTypes = {
  side: PropTypes.oneOf(['home', 'away']),
  teamColor: PropTypes.string,
  coach: PropTypes.shape({
    name: PropTypes.string,
    photoUrl: PropTypes.string
  }).isRequired
};

CoachCard.defaultProps = {
  side: 'home',
  teamColor: ''
};

const MatchDetailLineupsCoaches = ({ homeTeam, awayTeam }) => {
  var homeCoach = getCoachData(homeTeam);
  var awayCoach = getCoachData(awayTeam);

  var homeColor = (homeTeam && homeTeam.teamColor) || '';
  var awayColor = (awayTeam && awayTeam.teamColor) || '';

  return (
    <div className="lineups-coaches">
      <div className="lineups-coaches__col lineups-coaches__col--home">
        <CoachCard side="home" coach={homeCoach} teamColor={homeColor} />
      </div>
      <div className="lineups-coaches__col lineups-coaches__col--away">
        <CoachCard side="away" coach={awayCoach} teamColor={awayColor} />
      </div>
    </div>
  );
};

MatchDetailLineupsCoaches.propTypes = {
  homeTeam: PropTypes.shape({
    coach: PropTypes.shape({
      name: PropTypes.string,
      photoUrl: PropTypes.string
    }),
    coachName: PropTypes.string,
    coachPhotoUrl: PropTypes.string,
    coachImage: PropTypes.string
  }),
  awayTeam: PropTypes.shape({
    coach: PropTypes.shape({
      name: PropTypes.string,
      photoUrl: PropTypes.string
    }),
    coachName: PropTypes.string,
    coachPhotoUrl: PropTypes.string,
    coachImage: PropTypes.string
  })
};

MatchDetailLineupsCoaches.defaultProps = {
  homeTeam: null,
  awayTeam: null
};

export default MatchDetailLineupsCoaches;



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailLineupsCoaches/MatchDetailLineupsCoaches.jsx